import React from 'react';
import './vacancy.scss';

export function Vacancy() {
  return (
    <section id="vacancy">
      <h2 className='vacancy-title'>Вакансии</h2>
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3"></div>
        
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
          <div className='vacancy-thumbnail'>
            <img src="/img/vacancy/naoli-vet_vacancy.jpg" className="img-fluid" alt="Администратор дневной смены" />
            <div className='vacancy-caption'>
              <h4>Ассистент дневной смены</h4>
              <p>Желательно профильное среднее или высшее ветеринарное образование и опыт работы</p>
            </div>
          </div>
        </div>

      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <h3 className="center">Ждём от вас:</h3>
        <ul className='vacancy-list'>
          <li>Доброжелательность</li>
          <li>Стрессоустойчивость</li>
          <li>Ответственность</li>
          <li>Исполнительность</li>
          <li>Непременно любовь к животным</li>
        </ul>
        <h3 className="center">Звоните!</h3>
        <h3 className="center"><a href="tel:88129213626">(812) 921 36 26</a></h3>
      </div>
  </div>
</section>
  );
}
